import { createActionType } from "helpers/reduxHelpers";

export const GET_ALL_SCRIPT = createActionType("GET_ALL_SCRIPT");
export const GET_SINGLE_SCRIPT = createActionType("GET_SINGLE_SCRIPT");
